/**
 * تبدیل خروجی PersianDatePicker / react-multi-date-picker به فرمت تاریخ شمسی مورد انتظار API (YYYY-MM-DD)
 */
export function jalaliValueToApi(value) {
  if (value == null || value === '') return '';
  if (typeof value === 'string') {
    const s = value.trim().replace(/\//g, '-');
    return s.split(/\s+/)[0];
  }
  if (typeof value.format === 'function') {
    try {
      return String(value.format('YYYY/MM/DD')).replace(/\//g, '-');
    } catch {
      /* noop */
    }
  }
  if (value.year != null && value.month != null && value.day != null) {
    const pad = (n) => String(n).padStart(2, '0');
    const monthNum = typeof value.month === 'object' ? value.month.number : value.month;
    return `${value.year}-${pad(monthNum)}-${pad(value.day)}`;
  }
  return '';
}

/** ماه/روز فیلتر API را با صفر پیش‌رو (مثلاً 03، 06) برمی‌گرداند */
export function padJalaliFilterPart(value) {
  if (value == null || value === '') return value;
  const n = Number(value);
  if (!Number.isNaN(n) && Number.isFinite(n)) {
    return String(n).padStart(2, '0');
  }
  const s = String(value).trim();
  return /^\d{1,2}$/.test(s) ? s.padStart(2, '0') : s;
}
